import React from 'react';

export function CustomArrow(props) {
  const { className, onClick } = props;
  return <div className={className} onClick={onClick} style={{ display: props.visible ? 'block' : 'none' }} />;
}
